/**
 * Centralized Feature Flags — Frontend MVP Configuration
 *
 * Controls visibility of features across the entire frontend.
 * To re-enable any feature, change the flag to `true` or set the
 * corresponding REACT_APP_ environment variable.
 *
 * These flags mirror the backend configuration and should stay in sync.
 */

const FEATURE_FLAGS = {
  whatsappEnabled: process.env.REACT_APP_FEATURE_WHATSAPP_ENABLED === 'true',
  proPlanEnabled: process.env.REACT_APP_FEATURE_PRO_PLAN_ENABLED === 'true',
};

/**
 * Filters channel access object to respect global feature flags.
 */
export function filterChannelAccess(channelAccess) {
  return {
    email: channelAccess?.email ?? true,
    sms: channelAccess?.sms ?? false,
    whatsapp: FEATURE_FLAGS.whatsappEnabled ? (channelAccess?.whatsapp ?? false) : false,
  };
}

/**
 * Returns whether a plan should be shown in the UI.
 */
export function isPlanVisible(planId) {
  if (planId === 'pro' && !FEATURE_FLAGS.proPlanEnabled) return false;
  return true;
}

/**
 * Returns whether a channel should be shown in UI.
 */
export function isChannelVisible(channel) {
  if (channel === 'whatsapp' && !FEATURE_FLAGS.whatsappEnabled) return false;
  return true;
}

export default FEATURE_FLAGS;
